import React, { useState } from "react";
import clsx from "clsx";
import { makeStyles } from "@material-ui/core/styles";
import Loading from "./Loading";
import ImageFallback from "./ImageFallback";

const subdomainPrefix = process.env.REACT_APP_ENV === "dev" ? "dev" : "";

const useStyles = makeStyles(theme => ({
  container: {
    width: "100%"
  },
  fallback: {
    width: "100%",
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    paddingTop: "100%",
    background: theme.palette.divider
  },
  content: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translateX(-50%) translateY(-50%)"
  }
}));

const ImageLoader = ({
  className = "",
  imgKey,
  circularProgressSize,
  thumb = false,
  title = ""
}) => {
  const classes = useStyles();

  const [loading, setLoading] = useState(true);
  const renderS3Image = () => {
    if (!Boolean(imgKey)) {
      return (
        <div className={clsx(classes.container, className)}>
          <div className={classes.fallback}>
            <span className={classes.content}>
              <ImageFallback />
            </span>
          </div>
        </div>
      );
    }

    if (thumb) {
      let parts = imgKey.split("/");
      let file = parts[parts.length - 1];
      parts[parts.length - 1] = `thumbnail-${file}`;
      imgKey = parts.join("/");
    }

    return (
      <div className={clsx(classes.container, className)} title={title}>
        {loading && (
          <div className={classes.fallback}>
            <span className={classes.content}>
              <Loading circularProgressSize={circularProgressSize} />
            </span>
          </div>
        )}
        <img
          className={loading ? "d-none" : ""}
          src={`https://${subdomainPrefix}media.carritofacil.cl/?key=${imgKey}`}
          alt={title}
          onLoad={() => setLoading(false)}
        />
      </div>
    );
  };

  return renderS3Image();
};

export default ImageLoader;
